import backendVerifiedUser from "../../api/backendVerifiedUser";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import {
  SET_REVIEWS,
  RESET_REVIEWS,
  SET_SPECIFIC_REVIEW,
  RESET_SPECIFIC_REVIEW,
  SET_REVIEW_LOADING,
  RESET_REVIEW_LOADING,
} from "../Types/ReviewsTypes";

export const getReviews = () => {
  return async (dispatch) => {
    dispatch({ type: SET_REVIEW_LOADING });
    try {
      const response = await backendVerifiedUser.get("/get-reviews");
      dispatch({ type: RESET_REVIEW_LOADING });
      dispatch({ type: SET_REVIEWS, payLoad: response.data });
    } catch (err) {
      dispatch({ type: RESET_REVIEW_LOADING });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error fetching reviews",
      });
    }
  };
};

export const getSpecificReview = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_REVIEW_LOADING });
    try {
      const response = await backendVerifiedUser.get(`/get-specific-review/${id}`);
      dispatch({ type: RESET_REVIEW_LOADING });
      dispatch({ type: SET_SPECIFIC_REVIEW, payLoad: response.data });
    } catch (err) {
      dispatch({ type: RESET_REVIEW_LOADING });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error fetching review",
      });
    }
  };
};

export const addReview = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/add-review", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error adding review",
      });
      return false;
    }
  };
};

export const updateReview = (data, id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/update-review/${id}`, data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error updating review",
      });
      return false;
    }
  };
};

export const deleteReview = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(`/delete-review/${id}`);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error deleting review",
      });
      return false;
    }
  };
};

export const bulkUpdateReviews = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/bulk-update-reviews", data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error updating reviews",
      });
      return false;
    }
  };
};

export const approveReview = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/approve-review/${id}`);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error approving review",
      });
      return false;
    }
  };
};

export const rejectReview = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/reject-review/${id}`);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg || "Error rejecting review",
      });
      return false;
    }
  };
};
